import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { DTypeFormTimeRangesField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'timerangesconverter-field-component',
    templateUrl: './timerangesconverter-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DtypeTimeRangesConverterFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormTimeRangesField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    controlOriginal: FormControl;
    defaultValue: string;

    private _unsubscribeAll = new Subject<void>();

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        if (this.field.control.value === undefined || this.field.control.value === null) {
            this.field.control.setValue(this.field.default, { emitEvent: false });
        }

        const originalValue: string = this.field.control.value !== null && this.field.control.value !== undefined ?
            this.minutesToString(this.field.control.value) : '';

        const validators: ValidatorFn[] = [
            (control: AbstractControl) => this.field.required ? Validators.required(control) : null,
            Validators.pattern(/(^[0-9]+(d)((\s+[0-9]+(h))?(\s+[0-9]+(m)((\s+)?$)|(\s+)?$)|(\s+)?$))|(^[0-9]+(h)(\s+[0-9]+(m)((\s+)?$)|(\s+)?$))|(^[0-9]+(m)((\s+)?$))/)
        ];

        this.controlOriginal = new FormControl(originalValue, validators);
        if (this.field.control.disabled) {
            this.controlOriginal.disable();
        }
        this.defaultValue = this.controlOriginal.value;

        this.controlOriginal.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                distinctUntilChanged()
            )
            .subscribe((value) => {
                if (value === '') {
                    this.field.control.setValue(null);
                } else {
                    let totalMinutes = 0;
                    const timeData = value.split(' ');
                    if (!this.controlOriginal.errors?.pattern) {
                        for (const t of timeData) {
                            if (t.includes('d')) {
                                const days = Number(t.split('d')[0]);
                                totalMinutes += days * 24 * 60;
                            } else if (t.includes('h')) {
                                const hours = Number(t.split('h')[0]);
                                totalMinutes += hours * 60;
                            } else if (t.includes('m')) {
                                const minutes = Number(t.split('m')[0]);
                                totalMinutes += minutes;
                            }
                        }
                    } else {
                        totalMinutes = 0;
                    }
                    this.field.control.setValue(totalMinutes);
                }
            });

    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    private minutesToString(minutes: number) {
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        let str = '';
        minutes = minutes % 60;
        if (days > 0) {
            str = str + String(days) + 'd ';
        }
        if (hours > 0) {
            str = str + String(hours) + 'h ';
        }
        if (minutes > 0) {
            str = str + String(minutes) + 'm';
        }
        if (str === '') {
            return '0m';
        } else {
            return str;
        }
    }

}
